import React, { useEffect, useState } from 'react'
import ListLayout from '../../../../component/listLayout'
import AddButton from '../../../../component/AddButton'
import { Box, Button, FormControl, MenuItem, Select } from '@mui/material'
import InputSearch from '../../../../component/InputSearch'
import { useSelector } from 'react-redux'
import { Link, useSearchParams } from 'react-router-dom'
import { getAdjustsList, getBranchList } from '../../services/api'
import dayjs from 'dayjs'

export default function StockAdjustList() {
    const [branchs, setBranchs] = useState([])
    const [loading, setLoading] = useState(false)

    const { profile } = useSelector(state => state.profile)

    const [searchParams, setSearchParams] = useSearchParams()
    let id = searchParams.get('id') || ''
    let q = searchParams.get('q') || ''
    let b = searchParams.get('b') || ''
    let page = searchParams.get('page') || '1'
    const [data, setData] = useState([])
    // const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    useEffect(() => {
        const getList = async () => {
            setLoading(true)
            const data = await getAdjustsList(q, b, page, rowsPerPage)
            setData(data)
            setLoading(false)
        }
        getList()
    }, [q, b, page, rowsPerPage])
    useEffect(() => {
        const getBranch = async () => {
            const data = await getBranchList()
            setBranchs(data)
        }
        getBranch()
    }, [])

    const head = [
        'ที่',
        'ศูนย์เมล็ดพันธุ์ข้าว',
        'วันที่เอกสาร',
        'เลขที่เอกสาร',
        'รายการ',
        'ผู้ทำรายการ',
        'สถานะ',
        'ดำเนินการ',
    ]
    const body = data?.items?.map((x, i) => {

        return {
            id: x?.AdjustNo,
            item1: (data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i,
            item2: x?.BranchNo?.BranchName,
            item3: dayjs(x?.ReceiveDate).format('DD/MM/BBBB'),
            item4: x?.AdjustNo,
            item5: x?.IsAddedType ? 'ปรับปรุงเข้า' : 'ปรับปรุงออก',
            item6: x?.ModifiedId,
            item7: x?.Status === 'D' ?
                <span class="status-draft">
                    บันทึกร่าง
                </span> : x?.Status === 'W' ?
                    <span class="status-wait">
                        รออนุมัติ
                    </span> : x?.Status === 'Y' ?
                        <span class="status-active">
                            เสร็จสิ้น
                        </span> : x?.Status === 'N' ?
                            <span class="status-inactive">
                                ยกเลิก
                            </span> : '',

            item8: <Link to={`/stock/stock-adjust/${x.AdjustNo}`} onClick={() => setSearchParams({ id: x?.AdjustNo, page: page, q: q, b: b, })}>
                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
            </Link>
            ,
        }
    })
    return (
        <ListLayout title={'รายการปรับปรุงยอด'} action={<>
            <AddButton link={'/stock/stock-adjust/add'} />
            {
                profile?.BranchNo?.BranchNo === '00' &&
                <Box className="col-lg-2 col-md-12 ">
                    <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                        <FormControl variant="standard" fullWidth >
                            <Select value={b || 'all'}
                                onChange={e => setSearchParams({ q: q, b: e.target.value })}
                                disableUnderline
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                <MenuItem value='all'>ทั้งหมด</MenuItem>
                                {branchs?.map((x, i) => (
                                    <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Box >
            }
            <InputSearch value={q} onChange={e => setSearchParams({ q: e.target.value, b: b })} placeholder={"ค้นหา เลขที่เอกสาร"} />
        </>} loading={loading} head={head} body={body} pagination={{
            count: data?.meta?.totalPages,
            page: +page,
            event: { q: q, b: b, id: id }
        }} id={id} setSearchParams={setSearchParams} />
    )
}
